export enum TyreProfileMeasurementSystem {
  Millimeters = 'mm',
  Inches = 'inch'
}
